import { h, Component } from 'preact';

import { joinClasses } from 'utils/utils';

import s from 'components/bolt/input/input.sss';

export default class Input extends Component {

	constructor(props) {
		super(props);
		this.onInput = this.onInput.bind(this);
		this.onFocus = this.onFocus.bind(this);
		this.onBlur = this.onBlur.bind(this);
		this.state.value = props.value || '';
		this.state.focused = false;
	}

	get value() {
		return this.state.value;
	}
	set value(value) {
		this.setState({ value });
	}

	focus() {
		if (this.$input) {
			this.$input.focus();
		}
	}
	blur() {
		if (this.$input) {
			this.$input.blur();
		}
	}

	onInput(e) {
		let value = e.target.value;
		this.setState({ value });
		if (typeof this.props.onInput === 'function') {
			this.props.onInput({ value });
		}
	}

	// Focus events order: focusout, focusin, blur, focus (https://stackoverflow.com/a/20340215)
	onFocus() {
		this.blurring = false;
		if (!this.state.focused) {
			this.setState({ focused: true });
			if (typeof this.props.onFocus === 'function') {
				this.props.onFocus();
			}
		}
	}
	onBlur() {
		this.blurring = true;
		// Wait for next event loop so that next focus events are triggered
		setTimeout(() => {
			if (!this.blurring || !this.state.focused) {
				return;
			}
			this.setState({ focused: false });
			if (typeof this.props.onBlur === 'function') {
				this.props.onBlur();
			}
		}, 0);
	}

	render(props) {
		return (
			<label
				class={joinClasses(props.containerClass, {
					s,
					container: true,
					error: props.error
				}, this.state.focused && 'focused')}
				onFocusIn={this.onFocus}
				onFocusOut={this.onBlur}
				onMouseDown={props.onMouseDown}
			>
				<input
					ref={e => this.$input = e}
					class={joinClasses(s.input, props.class, props.inputStyle)}
					placeholder={props.placeholder}
					disabled={props.disabled}
					value={this.state.value}
					onInput={this.onInput}
					onKeyDown={props.onKeyDown}
					aria-label={props.ariaLabel}
					role={props.role}
				/>
				<div class={s.errorMessage}>{props.error}</div>
				{props.children}
			</label>
		);
	}

}
